import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetSearchStatsAdsUseCase extends UseCase {
  constructor({repository, fromSearchParamsToStatsRequestVOMapper}) {
    super()

    this._repository = repository
    this._fromSearchParamsToStatsRequestVOMapper = fromSearchParamsToStatsRequestVOMapper
  }

  @inlineError
  async execute(searchParams) {
    const searchStatsRequestVO = this._fromSearchParamsToStatsRequestVOMapper.map({
      filters: searchParams
    })

    const [error, response] = await this._repository.getSearchStats({
      searchStatsRequestVO
    })

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}
